import { Input, makeStyles } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'
import { EditViewProps } from '../screen'

export function EditConversationNameView({
  value,
  onChangeValue,
}: EditViewProps) {
  const styles = useStyles()

  if (!value) {
    return null
  }

  return (
    <View style={styles.container}>
      <Input
        placeholder={'Enter name'}
        value={value}
        onChangeText={onChangeValue}
        autoFocus
        style={styles.textInput}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.colors?.white,
    margin: 10,
    padding: 10,
  },
  textInput: {
    color: theme.colors?.grey2,
  },
}))
